// ================================================= /
// ======   Statistics Row JS   ==================== /
// ================================================= /

/* global jQuery */

import gsap from 'gsap';

import animation from './animation';
import slider from './slider';

/**
 * Class for controlling the card deck element
 */
class DispatchSkinStatisticsRow {

	/**
	 * Constructs the class and sets up instance variables.
	 */
	constructor() {

		this.selector = '.js-statistics-row';
		this.statisticSelector = `${this.selector}__statistic`;

		this.statisticsRows = [];
	}

	/**
	 * Initializes the class, sets up events.
	 */
	initialize() {

		this.statisticsRows = jQuery( this.selector );

		if ( this.statisticsRows.length ) {

			this.events();
		}
	}

	/**
	 * Wires up events
	 */
	events() {

		this.eventDelegationParent = jQuery( '.site' );

		animation.addHook(
			this.selector,
			this.resolveAnimation.bind( this )
		);
		animation.addHook(
			this.selector,
			this.resetAnimation.bind( this ),
			false
		);
	}

	/**
	 * Handles slide change.
	 */
	handleSlideChange( statisticsRow ) {

	}

	/**
	 * Animation callbacks
	 */
	resolveAnimation( statisticsRow ) {

		gsap.to(
			statisticsRow.find( this.statisticSelector ),
			{ duration: 0.35, stagger: { each: 0.15, from: 'end' }, opacity: 1, y: 0, filter: 'grayscale(0%) blur(0px)' }
		);
	}
	resetAnimation( statisticsRow ) {

	}

}

const statisticsRow = new DispatchSkinStatisticsRow();
export default statisticsRow;



// WEBPACK FOOTER //
// ./src/js/inc/statistics-row.js